import React, { Component } from 'react'

import ReactGridLayout from 'react-grid-layout'
import clone from 'lodash/clone'

class BottomNav extends Component {

    constructor(props) {
        super(props)

        this.layout = []
        this.starter = {
            i:'replaceme', x:0,y:0,w:3,h:1,static:true
        }

        let col = -1 
        for (let i = 0; i < 12; i++) {
            let _starter = clone(this.starter)

            i % 2 == 0 ? col += 1 : col = col
            _starter.i = i.toString()
            i % 2 == 0 ? _starter.y = 0 : _starter.y = 1
            _starter.x = col * 3

            this.layout.push( _starter )
        }

        /*this.layout = [
            {i: 'a', x: 0, y: 0, w: 3, h: 1, static: true},
            {i: 'b', x: 3, y: 0, w: 3, h: 1, static: true},
            {i: 'c', x: 0, y: 1, w: 3, h: 1, static: true},
        ]*/
    }

    render() {
        let _layout = this.layout.map( function(x,i) {
            return (
                <div className="bottomnavelement" key={x.i}>Test {x.i}</div>
            )
        })

        return (
            <div className='bottomnav'>
                <ReactGridLayout layout={this.layout} cols={24} rowHeight={30} width={1200} useCSSTransforms={false}>
                    {_layout}
                </ReactGridLayout>
            </div>
        )
    }
}

export default BottomNav



// WEBPACK FOOTER //
// ./src/components/BottomNav.js